import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { CategoryDialogData } from '@app/shared/components/dialogs/add-category-dialog/category-dialog.data';

@Component({
    selector : 'category-dialog',
    template: require('./category-dialog.component.html'),
    styles: [require('./category-dialog.component.scss')]
})
export class CategoryDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: CategoryDialogData) {
    }

    // public close() {
    //     this.dialogRef.close();
    // }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/add-category-dialog/category-dialog.component.ts